export const CONNECTION_EVENTS = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  CONNECT_ERROR: 'connect_error',
  ERROR: 'error',
} as const;

export const MESSAGE_EVENTS = {
  MESSAGE_ADDED: 'message_added',
} as const;

export const CHAT_EVENTS = {
  CHAT_CREATED: 'chat_created',
  CHAT_CLOSED: 'chat_closed',
} as const;

export const CALL_EVENTS = {
  CALL_STARTED: 'call started',
  CALL_ENDED: 'call ended',
} as const;

export const REQUISITION_EVENTS = {
  REQUISITION_INFORMATION: 'requisition_information',
} as const;

export const AUTH_EVENTS = {
  NO_TOKEN: 'NO_TOKEN',
  TOKEN_INVALID: 'TOKEN_INVALID',
  NO_DEVICE_ID: 'NO_DEVICE_ID',
} as const;

export const SYSTEM_EVENTS = {
  DISCONNECT_THROUGH_MULTIPLE_DEVICES: 'DISCONNECT_THROUGH_MULTIPLE_DEVICES',
} as const;

export type ConnectionEvent = typeof CONNECTION_EVENTS[keyof typeof CONNECTION_EVENTS];
export type MessageEvent = typeof MESSAGE_EVENTS[keyof typeof MESSAGE_EVENTS];
export type ChatEvent = typeof CHAT_EVENTS[keyof typeof CHAT_EVENTS];
export type AuthEvent = typeof AUTH_EVENTS[keyof typeof AUTH_EVENTS];
export type SystemEvent = typeof SYSTEM_EVENTS[keyof typeof SYSTEM_EVENTS];
export type RequisitionEvent = typeof REQUISITION_EVENTS[keyof typeof REQUISITION_EVENTS];
export type CallEvent = typeof CALL_EVENTS[keyof typeof CALL_EVENTS];

export type SocketIoProviderEvents =
  | ConnectionEvent
  | MessageEvent
  | ChatEvent
  | AuthEvent
  | SystemEvent
  | RequisitionEvent
  | CallEvent;
